<i18n>
{
  "en": {
    "groups": "Groups",
    "highProfitability": "Section with high estimated profitability",
    "lowProfitability": "Section with low estimated profitability",
    "menuProductBoostLegend": "The marked section has product boosted."
  },
  "es": {
    "groups": "Agrupaciones",
    "highProfitability": "Sección con alta rentabilidad estimada",
    "lowProfitability": "Sección con baja rentabilidad estimada",
    "menuProductBoostLegend": "La sección marcada contiene productos promocionados."
  }
}
</i18n>

<template>
  <dynameat-info-modal>
    <v-container>
      <div class="d-flex justify-space-around body-2 text-center text-md-left">{{ $t('groups') }}</div>
      <legend-group-chips :default-width="70" :group-info="groupList" class="d-flex flex-wrap justify-center"/>
      <v-divider class="d-flex my-5"></v-divider>
      <div class="d-flex flex-row body-2 align-center justify-center text-md-left ml-5">
        <v-badge bordered icon="mdi-rocket-launch" left overlap color="red" class="rocket-boost"/>
        <div class="width-90 ml-3">{{ $t('menuProductBoostLegend') }}</div>
      </div>
    </v-container>
  </dynameat-info-modal>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Components, MapGetters } from '@core/helpers/decorators';
import DynameatInfoModal from '@dynameat/components/DynameatInfoModal';
import LegendGroupChips from '@optimizer/components/LegendGroupChips.vue';

@Component
@Components({ DynameatInfoModal, LegendGroupChips })
@MapGetters(['groupList'])
export default class MenuEngineeringGroupInfoButton extends Vue {
}
</script>

<style scoped>
.chip {
  min-width: 3em;
  justify-content: center;
}

.v-chip--disabled {
  opacity: 1;
}

.rocket-boost {
  right: 11px;
}
</style>
